import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { DateFormatService } from './dateFormat.service';
import { format } from 'date-fns';

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  constructor(private dateFormatService: DateFormatService) {
    super();
  }

  override format(date: Date, _displayFormat: string): string {
    return format(date, this.dateFormatService.userDateFormat);
  }
}
